import { useLayoutEffect, useState } from 'react';
// @mui
import { Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';
// server
import i18n from '../../../i18n';

// ----------------------------------------------------------------------

export default function LoginForm({
    username,
    setUsername,
    password,
    setPassword,
    handleClick,
    validationErrors,
    setValidationErrors,
    isLoading
}) {
    const [showPassword, setShowPassword] = useState(false);

    // Autofill check https://github.com/facebook/react/issues/1159#issuecomment-1025423604
    const [wasUsernameAutofilled, setWasUsernameAutofilled] = useState(false);
    const [wasPasswordAutofilled, setWasPasswordAutofilled] = useState(false);

    useLayoutEffect(() => {
        const checkAutofilled = () => {
            const usernameAutofilled = !!document
                .getElementById('username')
                ?.matches('*:-webkit-autofill');
            const passwordAutofilled = !!document
                .getElementById('password')
                ?.matches('*:-webkit-autofill');
            setWasUsernameAutofilled(usernameAutofilled);
            setWasPasswordAutofilled(passwordAutofilled);
        };
        // The time when it's ready is not very stable, so check few times
        setTimeout(checkAutofilled, 200);
        setTimeout(checkAutofilled, 500);
        setTimeout(checkAutofilled, 1000);
        setTimeout(checkAutofilled, 2000);
    }, []);

    const handleInput = (field, value) => {
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [field]: value.trim() === ''
        }));
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter' && username && password) {
            handleClick();
        }
    };

    return (
        <>
            <Stack spacing={3} sx={{ my: 2 }}>
                <TextField
                    size="medium"
                    required
                    error={validationErrors.username}
                    helperText="Enter username"
                    id="username"
                    name="username"
                    label="Username"
                    value={username}
                    onChange={(event) => {
                        handleInput('username', event.target.value);
                        setUsername(event.target.value);
                    }}
                    onKeyDown={onKeyDown}
                    InputLabelProps={{
                        shrink: wasUsernameAutofilled || username.length > 0
                    }}
                />

                <TextField
                    size="medium"
                    required
                    error={validationErrors.password}
                    helperText="Enter password"
                    id="password"
                    name="password"
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(event) => {
                        handleInput('password', event.target.value);
                        setPassword(event.target.value);
                    }}
                    onKeyDown={onKeyDown}
                    InputLabelProps={{
                        shrink: wasPasswordAutofilled || password.length > 0
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() =>
                                        setShowPassword(!showPassword)
                                    }
                                    edge="end"
                                >
                                    <Iconify
                                        icon={
                                            showPassword
                                                ? 'eva:eye-fill'
                                                : 'eva:eye-off-fill'
                                        }
                                    />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </Stack>

            <LoadingButton
                loading={isLoading}
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={handleClick}
            >
                {i18n.t('common.login')}
            </LoadingButton>
        </>
    );
}
